<template>
  <div>
    <h3 v-if="betaVisibility">Recently Viewed: Resources</h3>
    <h3 v-else>Recent Downloads</h3>
    <p class="loading-notice text-muted" v-if="loading"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading recent downloads...</p>
    <div
      class="alert alert-danger"
      role="alert"
      v-if="error">Error loading recent downloads. Please refresh the page and try again.</div>
    <ResourcePreviewCard
      v-for="download, idx in downloads"
      :key="download.uuid"
      v-bind="download"
      :show-resource-type="false"
      :screenshots="download.screenshots"
      :omit-description="true"
      :new-homepage="true"
      :position="idx + 1">
      <template v-slot:resource-details>
        <p><small class="text-muted">Grade {{ download.grades.join(', ') }} - {{ getResourceSubjectLabelsFromValues(download.subjects).join(', ') }}</small></p>
      </template>
    </ResourcePreviewCard>
    <a v-if="downloads.length && betaVisibility" :href="`${this.home}/v/library/recently_viewed/resources?beta=true`">View more resources</a>
    <router-link v-if="downloads.length && !betaVisibility" :to="{name: 'RecentDownloads', query: {ref: 'home'}}">View more downloads</router-link>

    <div class="empty-downloads" v-if="!downloads.length" >
      <p class="empty-msg">You haven’t downloaded anything yet. Discover resources below:</p>
      <ul>
        <li>
          <p>Identify your student's present levels:</p>
          <router-link :to="{name: 'BrowseAssessments', query: {subject: 'Reading', ref: 'home_empty_downloads'}}">Browse Baseline Assessments</router-link>
        </li>
        <li>
          <p>Find progress monitoring assessments:</p>
          <router-link :to="{name: 'BrowseGoalsWizard', query: {ref: 'home_empty_downloads'}}">Learning Goal Wizard</router-link>
        </li>
        <li>
          <p>Discover instructional resources:</p>
          <router-link :to="{name: 'StrategyWizard', query: {ref: 'home_empty_downloads'}}">Strategy Wizard</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

  <script>
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import ResourcePreviewCard from '@/components/ResourcePreviewCard'
  import { getUserDownloads } from '@/api/downloads'
  import { noSelMixin } from '@/contentprofile/no_sel_mixins'
  import { toolkitUrls } from '@/links'

  export default {
    name: 'RecentDownloadsHome',
    components: {
      ResourcePreviewCard,
    },
    mixins: [noSelMixin],
    data() {
      return {
        ...toolkitUrls,
        loading: true,
        error: false,
        downloads: []
      }
    },
    computed: {
      ...mapState('user', {
        userUuid: state => state.user.uuid,
        fetchingUser: state => state.fetching
      }),
      ...mapGetters('visibility', ['betaVisibility'])
    },
    methods: {
    ...mapMutations('user', ['pushOnetimeCallback']),
    async retrieveDownloads() {
      try {
        const data = await getUserDownloads({full: true, limit: '3'})
        this.downloads = (data.collection.content || []).map(res => res.content_body)
      } catch (err) {
        console.error(err)
        this.error = true
      } finally {
        this.loading = false
      }
    }
  },
  async created () {
    if (!this.fetchingUser && this.userUuid) {
      await this.retrieveDownloads()
    } else {
      this.pushOnetimeCallback(async () => {
        if (this.userUuid) {
          await this.retrieveDownloads()
        }
      })
    }
  },
    eventContext() {
      return {
        ref: 'home',
      }
    }
  };
  </script>

  <style lang="less" scoped>
  @import '~@/variables.less';
  h3 {
      margin-bottom: 0;
      color: @header-text-dark;
  }
  a:focus {
    outline: 2px solid lighten(@link-color, 20%);;
    outline-offset: 3px;
  }
  .empty-downloads {
    & > p {
      font-style: italic;
    }
    & > ul {
      list-style: none;
      margin-top: 1rem;

      & > li {
        margin-bottom: 1rem;

        & > p {
          margin-bottom: 0;
        }
      }
    }
  }


  </style>